import { render, staticRenderFns } from "./RegistrationConfirmationRoot.vue?vue&type=template&id=2894e733&"
import script from "./RegistrationConfirmationRoot.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmationRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports